/**
 * Detecta ventas del POS.
 * Nuevo: origen === 'pos'
 * Legacy: origen === 'mostrador' && detalle_cliente === 'Venta POS'
 */
export function esVentaPos(p) {
    if (!p) return false;
    if (p.origen === 'pos') return true;
    return p.origen === 'mostrador' && p.detalle_cliente === 'Venta POS';
}

/** Igual que esVentaPos, para filas de movimientos_stock con join a pedidos. */
export function esVentaPosRef(m) {
    if (!m) return false;
    if (m.motivo === 'venta_pos' || m.ref_pedido_origen === 'pos') return true;
    return m.ref_pedido_origen === 'mostrador' && m.ref_pedido_detalle === 'Venta POS';
}

/** Pedido abierto de una mesa (salón de bares/restaurantes). */
export function esPedidoMesa(p) {
    return !!(p && p.origen === 'mesa');
}

/** Mesa todavía "en curso" (no cobrada): sigue apareciendo en Pedidos hasta que se cobre. */
export function esMesaEnCurso(p) {
    return esPedidoMesa(p) && p.mesa_id != null && p.estado !== 'cerrado';
}

export function etiquetaOrigenPedido(p) {
    if (esVentaPos(p)) return 'POS';
    if (esPedidoMesa(p)) return 'Mesa';
    if (p && p.origen === 'mostrador') return 'Mostrador';
    return 'Menú online';
}
